import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
} from "./actionTypes"

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  userData: null,
}

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        userData: null,
      }
      break
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload.message,
        userData: action.payload.data,
      }
      break
    case FORGET_PASSWORD_ERROR:
      state = { 
        ...state, 
        forgetError: action.payload,
        userData: null,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default forgetPassword
